// @ts-expect-error
import { ITEM_TYPES } from '@wix/advanced-seo-utils/dist/src/private/types/ItemTypes';
import { getImageMetadataFromWixMedia } from './utils/cover-image-utils';
export const decorateCategoryWithSeoAttributes = ({ category, sectionUrl, useNewSeoData, }) => {
    const seoData = useNewSeoData ? { seoData: category.seoData } : {};
    return Object.assign(Object.assign({}, seoData), { itemType: ITEM_TYPES.FORUM_CATEGORY, itemData: {
            category: Object.assign(Object.assign({}, category), { title: category.label, description: category.description, images: category.cover
                    ? [getImageMetadataFromWixMedia(category.cover)]
                    : [], videos: [], refersTo: `${sectionUrl}/${category.slug}` }),
        } });
};
//# sourceMappingURL=decorate-category-with-seo-attributes.js.map